<template>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
   viewBox="0 0 454.7 145.5" style="enable-background:new 0 0 454.7 145.5;" xml:space="preserve">
    <g>
      <defs>
        <rect id="t12_1_" y="43.8" width="57.9" height="57.9"/>
      </defs>
      <clipPath id="t12_2_">
        <use xlink:href="#t12_1_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st0">
        <g>
          <defs>
            <path id="t12_3_" d="M0,92.7V52.8c0-5,4-9,9-9h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9H9C4,101.7,0,97.7,0,92.7z"/>
          </defs>
          <clipPath id="t12_4_">
            <use xlink:href="#t12_3_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st1">
            <path class="st2" d="M0,101.7V43.8h57.9v57.9H0z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t12_5_" x="270.9" width="57.9" height="57.9"/>
      </defs>
      <clipPath id="t12_6_">
        <use xlink:href="#t12_5_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st3">
        <g>
          <defs>
            <path id="t12_7_" d="M270.9,48.9V9c0-5,4-9,9-9h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9h-39.9C275,57.9,270.9,53.9,270.9,48.9z"/>
          </defs>
          <clipPath id="t12_8_">
            <use xlink:href="#t12_7_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st4">
            <path class="st2" d="M270.9,57.9V0h57.9v57.9H270.9z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t12_9_" x="270.9" y="87.6" width="57.9" height="57.9"/>
      </defs>
      <clipPath id="t12_10_">
        <use xlink:href="#t12_9_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st5">
        <g>
          <defs>
            <path id="t12_11_" d="M270.9,136.5V96.6c0-5,4-9,9-9h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9h-39.9
              C275,145.5,270.9,141.5,270.9,136.5z"/>
          </defs>
          <clipPath id="t12_12_">
            <use xlink:href="#t12_11_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st6">
            <path class="st2" d="M270.9,145.5V87.6h57.9v57.9H270.9z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t12_13_" x="347.8" width="57.9" height="57.9"/>
      </defs>
      <clipPath id="t12_14_">
        <use xlink:href="#t12_13_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st7">
        <g>
          <defs>
            <path id="t12_15_" d="M347.8,48.9V9c0-5,4-9,9-9h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9h-39.9C351.9,57.9,347.8,53.9,347.8,48.9z"
              />
          </defs>
          <clipPath id="t12_16_">
            <use xlink:href="#t12_15_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st8">
            <path class="st2" d="M347.8,57.9V0h57.9v57.9H347.8z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t12_17_" x="347.8" y="87.6" width="57.9" height="57.9"/>
      </defs>
      <clipPath id="t12_18_">
        <use xlink:href="#t12_17_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st9">
        <g>
          <defs>
            <path id="t12_19_" d="M347.8,136.5V96.6c0-5,4-9,9-9h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9h-39.9
              C351.9,145.5,347.8,141.5,347.8,136.5z"/>
          </defs>
          <clipPath id="t12_20_">
            <use xlink:href="#t12_19_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st10">
            <path class="st2" d="M347.8,145.5V87.6h57.9v57.9H347.8z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t12_21_" x="368.4" y="43.8" width="86.3" height="57.9"/>
      </defs>
      <clipPath id="t12_22_">
        <use xlink:href="#t12_21_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st11">
        <g>
          <defs>
            <path id="t12_23_" d="M368.4,92.7V52.8c0-5,4-9,9-9h68.2c5,0,9,4,9,9v39.9c0,5-4,9-9,9h-68.2
              C372.4,101.7,368.4,97.7,368.4,92.7z"/>
          </defs>
          <clipPath id="t12_24_">
            <use xlink:href="#t12_23_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st12">
            <path class="st2" d="M368.4,101.7V43.8h86.2v57.9H368.4z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t12_25_" x="194" width="57.9" height="57.9"/>
      </defs>
      <clipPath id="t12_26_">
        <use xlink:href="#t12_25_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st13">
        <g>
          <defs>
            <path id="t12_27_" d="M194,48.9V9c0-5,4-9,9-9h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9H203C198,57.9,194,53.9,194,48.9z"/>
          </defs>
          <clipPath id="t12_28_">
            <use xlink:href="#t12_27_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st14">
            <path class="st2" d="M194,57.9V0h57.9v57.9H194z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t12_29_" x="116.9" width="57.9" height="57.9"/>
      </defs>
      <clipPath id="t12_30_">
        <use xlink:href="#t12_29_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st15">
        <g>
          <defs>
            <path id="t12_31_" d="M116.9,48.9V9c0-5,4-9,9-9h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9h-39.9C121,57.9,116.9,53.9,116.9,48.9z"/>
          </defs>
          <clipPath id="t12_32_">
            <use xlink:href="#t12_31_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st16">
            <path class="st2" d="M116.9,57.9V0h57.9v57.9H116.9z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t12_33_" x="46" y="43.8" width="57.9" height="57.9"/>
      </defs>
      <clipPath id="t12_34_">
        <use xlink:href="#t12_33_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st17">
        <g>
          <defs>
            <path id="t12_35_" d="M46,92.7V52.8c0-5,4-9,9-9h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9H55C50,101.7,46,97.7,46,92.7z"/>
          </defs>
          <clipPath id="t12_36_">
            <use xlink:href="#t12_35_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st18">
            <path class="st2" d="M46,101.7V43.8h57.9v57.9H46z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t12_37_" x="43.8" y="0" width="57.9" height="57.9"/>
      </defs>
      <clipPath id="t12_38_">
        <use xlink:href="#t12_37_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st19">
        <g>
          <defs>
            <path id="t12_39_" d="M52.8,0h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9H52.8c-5,0-9-4-9-9V9C43.8,4,47.8,0,52.8,0z"/>
          </defs>
          <clipPath id="t12_40_">
            <use xlink:href="#t12_39_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st20">
            <path class="st2" d="M43.8,0h57.9v57.9H43.8V0z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t12_41_" x="43.8" y="87.6" width="57.9" height="57.9"/>
      </defs>
      <clipPath id="t12_42_">
        <use xlink:href="#t12_41_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st21">
        <g>
          <defs>
            <path id="t12_43_" d="M52.8,87.6h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9H52.8c-5,0-9-4-9-9V96.6C43.8,91.6,47.8,87.6,52.8,87.6z"
              />
          </defs>
          <clipPath id="t12_44_">
            <use xlink:href="#t12_43_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st22">
            <path class="st2" d="M43.8,87.6h57.9v57.9H43.8V87.6z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t12_45_" x="116.9" y="87.6" width="57.9" height="57.9"/>
      </defs>
      <clipPath id="t12_46_">
        <use xlink:href="#t12_45_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st23">
        <g>
          <defs>
            <path id="t12_47_" d="M125.9,87.6h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9h-39.9c-5,0-9-4-9-9V96.6C116.9,91.6,121,87.6,125.9,87.6
              z"/>
          </defs>
          <clipPath id="t12_48_">
            <use xlink:href="#t12_47_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st24">
            <path class="st2" d="M116.9,87.6h57.9v57.9h-57.9V87.6z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t12_49_" x="194" y="87.6" width="57.9" height="57.9"/>
      </defs>
      <clipPath id="t12_50_">
        <use xlink:href="#t12_49_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st25">
        <g>
          <defs>
            <path id="t12_51_" d="M194,136.5V96.6c0-5,4-9,9-9h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9H203C198,145.5,194,141.5,194,136.5z"/>
          </defs>
          <clipPath id="t12_52_">
            <use xlink:href="#t12_51_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st26">
            <path class="st2" d="M194,145.5V87.6h57.9v57.9H194z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t12_53_" x="10.2" y="10.2" width="433.8" height="125.1"/>
      </defs>
      <clipPath id="t12_54_">
        <use xlink:href="#t12_53_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st27">
        <g>
          <defs>
            <path id="t12_55_" d="M24.2,10.2h405.9c7.7,0,14,6.3,14,14v97.1c0,7.7-6.3,14-14,14H24.2c-7.7,0-14-6.3-14-14V24.2
              C10.2,16.5,16.5,10.2,24.2,10.2z"/>
          </defs>
          <clipPath id="t12_56_">
            <use xlink:href="#t12_55_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st28">
            <path class="st29" d="M10.2,10.2H444v125.1H10.2V10.2z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t12_57_" x="177.2" y="25.2" width="95.1" height="95.1"/>
      </defs>
      <clipPath id="t12_58_">
        <use xlink:href="#t12_57_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st30">
        <g>
          <defs>
            <circle id="t12_59_" cx="224.7" cy="72.8" r="47.6"/>
          </defs>
          <clipPath id="t12_60_">
            <use xlink:href="#t12_59_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st31">
            <path class="st2" d="M177.2,25.2h95.1v95.1h-95.1V25.2z"/>
          </g>
        </g>
      </g>
    </g>
  </svg>

</template>
<script>
  export default {
    name: 't12'
  }
</script>

<style scoped>
  svg {
    width: 100%;
    height: 100%;
  }
  .st0{clip-path:url(#t12_2_);}
  .st1{clip-path:url(#t12_4_);}
  .st2{fill:#2C6EDF;}
  .st3{clip-path:url(#t12_6_);}
  .st4{clip-path:url(#t12_8_);}
  .st5{clip-path:url(#t12_10_);}
  .st6{clip-path:url(#t12_12_);}
  .st7{clip-path:url(#t12_14_);}
  .st8{clip-path:url(#t12_16_);}
  .st9{clip-path:url(#t12_18_);}
  .st10{clip-path:url(#t12_20_);}
  .st11{clip-path:url(#t12_22_);}
  .st12{clip-path:url(#t12_24_);}
  .st13{clip-path:url(#t12_26_);}
  .st14{clip-path:url(#t12_28_);}
  .st15{clip-path:url(#t12_30_);}
  .st16{clip-path:url(#t12_32_);}
  .st17{clip-path:url(#t12_34_);}
  .st18{clip-path:url(#t12_36_);}
  .st19{clip-path:url(#t12_38_);}
  .st20{clip-path:url(#t12_40_);}
  .st21{clip-path:url(#t12_42_);}
  .st22{clip-path:url(#t12_44_);}
  .st23{clip-path:url(#t12_46_);}
  .st24{clip-path:url(#t12_48_);}
  .st25{clip-path:url(#t12_50_);}
  .st26{clip-path:url(#t12_52_);}
  .st27{clip-path:url(#t12_54_);}
  .st28{clip-path:url(#t12_56_);}
  .st29{fill:#85B0F9;}
  .st30{clip-path:url(#t12_58_);}
  .st31{clip-path:url(#t12_60_);}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/PosSettings/svg/t12.vue